import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "dat-landing" */ './DATMainLandingPage'));
export const DATEliteLandingPage = Loadable(
  () => import(/* webpackChunkName: "dat-landing" */ './DATEliteLandingPage'),
);
export const DATSelfPacedLandingPage = Loadable(
  () => import(/* webpackChunkName: "dat-landing" */ './DATSelfPacedLandingPage'),
);
